import { render, staticRenderFns } from "./BenefitsLevelModal.vue?vue&type=template&id=1f69ec4b&scoped=true&"
import script from "./BenefitsLevelModal.vue?vue&type=script&lang=ts&"
export * from "./BenefitsLevelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f69ec4b",
  null
  
)

export default component.exports